import React from 'react';

import { VpHookFormCheckbox, VpConditionalUpgradeWrapper } from '../..';
import { useFetchPluginById } from '../../../hooks';
import { PLUGIN_REMOVE_LOGO_ENABLED } from '../../../constants/feature-keys';

export const VpPluginLogoCheckbox = () => {
  const { data } = useFetchPluginById();

  return (
    <VpConditionalUpgradeWrapper fullWidth featureKey={PLUGIN_REMOVE_LOGO_ENABLED}>
      {({ isDisabled }) => (
        <VpHookFormCheckbox
          defaultValue={data?.showVideoPeelLogo}
          name="showVideoPeelLogo"
          label="VideoPeel Logo"
          disabled={isDisabled}
        />
      )}
    </VpConditionalUpgradeWrapper>
  );
};

export default VpPluginLogoCheckbox;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginLogoCheckbox.jsx